import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div className="container" style={{ textAlign: 'center', padding: '80px 20px' }}>
      <Helmet>
        <title>Page Not Found | Bunny Boutique 321</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <h1>404 - Page Not Found</h1>
      <p style={{ color: '#777', marginBottom: '30px' }}>
        Sorry, we couldn't find the page you were looking for.
      </p>
      <Link to="/" className="btn-primary">Back to Home</Link>
    </div>
  );
}

export default NotFound;
